import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { CssFolder } from './pages/css/index';
import { FontsFolder } from './pages/fonts/index';
import { ImagesFolder } from './pages/images';
import { StaticAssetList } from './pages/list';
import { JSONFolder } from './pages/files';

export const StaticAsset = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route exact path={`${match.path}/list`} component={StaticAssetList} />
            <Route exact path={`${match.path}/css`} component={CssFolder} />
            <Route exact path={`${match.path}/fonts`} component={FontsFolder} />
            <Route exact path={`${match.path}/images`} component={ImagesFolder} />
            <Route exact path={`${match.path}/json`} component={JSONFolder} />
            <Route path={`${match.path}/`} component={() => <Redirect to={`${match.path}/list`}/>} />
        </Switch>
    )
}
